// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-icon {
    position: relative;
    display: inline-block;
    cursor: pointer;
}

.tooltip-icon__tooltip {
    visibility: hidden;
    width: auto;
    background-color: white;
    color: black;
    font-weight: lighter;
    text-align: center;
    border-radius: 6px;
    padding: 5px 15px 5px 15px;
    position: absolute;
    z-index: 1;
    bottom: 10%; /* Position the tooltip above the icon */
    right: -20%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
}

.tooltip-icon__tooltip::after {
    content: '';
    position: absolute;
    top: 100%; /* Arrow at the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.tooltip-icon:hover .tooltip-icon__tooltip {
    visibility: visible;
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/tooltip/tooltip.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,WAAW,EAAE,wCAAwC;IACrD,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS,EAAE,uCAAuC;IAClD,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd","sourcesContent":[".tooltip-icon {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n}\n\n.tooltip-icon__tooltip {\n    visibility: hidden;\n    width: auto;\n    background-color: white;\n    color: black;\n    font-weight: lighter;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 15px 5px 15px;\n    position: absolute;\n    z-index: 1;\n    bottom: 10%; /* Position the tooltip above the icon */\n    right: -20%;\n    margin-left: -60px;\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.tooltip-icon__tooltip::after {\n    content: '';\n    position: absolute;\n    top: 100%; /* Arrow at the bottom of the tooltip */\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: #555 transparent transparent transparent;\n}\n\n.tooltip-icon:hover .tooltip-icon__tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
